import React from 'react';
import moment from 'moment';

import Link from '../../components/Link';
import {useAnalytics} from '../../hooks';

export const AskedAtInterview = ({question, interview = {}}) => {
  const {tracker} = useAnalytics();

  // company_name exists if a tag exists for this company
  const companyName = interview.company_name || interview.company;

  return companyName && (
    <span className="text-gray-600">
      {interview.company_logo && (
        <img
          className="inline h-5 w-5 mr-2 object-contain"
          alt={`${companyName} logo`}
          src={interview.company_logo}
        />
      )}
      Asked at
      {' '}
      <Link
        href={`/questions?company=${interview.company}`}
        onClick={() => tracker.questionClickInterviewCompany({
          company: interview.company,
          question: question.id,
          id: question.id,
        })}
      >
        {companyName}
      </Link>
      {interview.created_at && (
        <span className="whitespace-nowrap">
          {' '}
          {moment(interview.created_at).fromNow()}
        </span>
      )}
    </span>
  );
};

export const AskedAtInterviews = ({question, interviews = []}) => {
  const latestInterviewWithCompany = interviews.find(
    (interview) => interview.company_name || interview.company,
  );

  return (
    interviews.length > 0 && (
    <span className="text-gray-600">
      <AskedAtInterview
        question={question}
        interview={latestInterviewWithCompany || interviews[0]}
      />
      {interviews.length > 2 && (
        <span>
          {' '}
          and
          {' '}
          {interviews.length - 1}
          &nbsp;other&nbsp;times
        </span>
      )}
    </span>
    )
  );
};
